import {GET_PRODUCT_ANSWER_LIST,CLEAR_PRODUCT_ANSWER_LIST} from "../../constants/product-questions/getProductAnswerConst"

const initialState={
    success : false,
    productAnswerList:[],
    totalProductAnswerCount:0,
    loadedProductAnswerCount:0,
    productAnswerListPage:0,
    isAllQuestionAnswered:false
}

export default function productAnswerListReducer(state=initialState,action){
    switch (action.type) {
        case GET_PRODUCT_ANSWER_LIST:
            const temp=(state?.productAnswerList).concat(action?.payload?.questionData)
            return{

                    ...state,
                    success : action?.success,
                    productAnswerList:temp,
                    success : action?.success,
                    totalProductAnswerCount:action?.payload?.totalCount,
                    loadedProductAnswerCount:temp?.length,
                    productAnswerListPage: state?.productAnswerListPage + 1,
                    isAllQuestionAnswered:action?.payload?.isAllQuestionAnswered
            }
           
            case CLEAR_PRODUCT_ANSWER_LIST:
                return{
                    ...state,
                    productAnswerList:[],
                    totalProductAnswerCount:0,
                    loadedProductAnswerCount:0,
                    productAnswerListPage:0
                }
    
        default:
            return state
    }
}